import React, { useState, useEffect, Component }  from 'react'
import KycFlow from '../../kycQr'
import '../../App.css'
import './applyMarriageCert.css'

import { Document, Page, pdfjs } from 'react-pdf';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Navbar from '../../Navbar';
import Footer from '../Footer/Footer';
import axios from 'axios';
import data from "../../api";
import openSocket from "socket.io-client";
import 'bootstrap/dist/css/bootstrap.min.css';
import studentPhoto from '../../img/studentIcon.png'
import QRCode from 'qrcode.react';
import { renderToString } from 'react-dom/server'; 
import { toPng } from 'html-to-image';
import { JsonToTable } from "react-json-to-table";
import uploadBack from '../../img/auditBanerImg.jpeg'
import logo from '../../img/Logo-EarthID-white.png'
import '../HomePublic/test.css'
import crypto from 'crypto';
import mammoth from 'mammoth';
import { extract } from 'png-metadata';
//import fileType from 'file-type'
import create from 'jpeg-js'

import { PDFDocument } from 'pdf-lib';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCalendar, faCheck, faCircleCheck, faEdit, faEye, faFileCircleCheck, faHome, faList, faQrcode, faQuestionCircle, faRightFromBracket, faUser } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faLinkedinIn, faTwitter } from '@fortawesome/free-brands-svg-icons';





const fs = require('fs');
const MySwal = withReactContent(Swal);
// export const isTestnet = true;
// const socketURL =
//     isTestnet === true
//         ? "https://socket-stagev2.myearth.id"
//         : "https://socketv2.myearth.id";
// const socket = openSocket(socketURL, {
//     transports: ["websocket", "polling", "flashsocket"],
// });
// let socketId;
// socket.on("connect", () => {
//     socketId = socket.id;
//     //console.log(`I'm connected with the back-end`);
// });



const {
    listenForUserData
} = data;

const ssiBaseUrl = "https://ssi-test.myearth.id";
const authorizationKey = "01a41742-aa8e-4dd6-8c71-d577ac7d463c";

// const privateKey = "6mf4ZKu2ts0V4Dr0sS+YbXYveZOyDezzTJUqa5Ls29BHN4jBTY5we/WW0CgmuNGb3PBvdqqJPhDF2YCMnF4faw==";
 const publicKey = "geMiBNanS2G0apweNStndbsBkKdc8rjzPtbP4N6EApg=";
 const issuerDid = "did:earthid:testnet:EvU7xs7swFEYqANkFDQDvSP97EzaVmVv3E5K5L3uKMXk;earthid:testnet:fid=0.0.4243508";
const userDID = "did:earthid:testnet:DsvEjMRKhboDb7GGYRL2P3BpV5htGx9QB2HPzSWpw89J;earthid:testnet:fid=0.0.4243508";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const ApplyMarriage = () => {



    const [files, setFiles] = useState([]);
    const [docID, setDocID] = useState(null);
    const [vcID, setVcID] = useState(null);
    const [responseData, setResponseData] = useState(null);
    const [responseDataID, setResponseDataID] = useState(null);
    const [responseDataTraining, setResponseDataTraining] = useState(null);
    const [responseDataMember, setResponseDataMember] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [pdfFile, setPdfFile] = useState(null);
    const [numPdfPages, setNumPdfPages] = useState(null);
    const [numPages, setNumPages] = useState([]);
    const [pdfMetaData, setPdfMetaData] = useState([]);
    const [pdfs, setPdfs] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [showMainContent, setShowMainContent] = useState(false); // State variable to track tab selection
    const [showAllDocs, setShowAllDocs] = useState(false);
    const [apiResponse, setApiResponse] = useState(null); // State variable to store API response
    const [vcResponse, setVcResponse] = useState(null); // State variable to store API response
    const [verifiableCredentials, setVerifiableCredentials] = useState([]);
    const [idVerifiableCredentials, setIdVerifiableCredentials] = useState([]);
    const [selectedDropCertificate, setSelectedDropCertificate] = useState('');
    const [showTable, setShowTable] = useState(false);
    const [profileData, setProfileData] = useState(null);
    const [selectedButton, setSelectedButton] = useState("");
    const [loading, setLoading] = useState(false); // Added loading state
    const [ qRCodeUrl, setQRCodeUrl] = useState(null);
    const [ onqRCodeUrl, setonQRCodeUrl] = useState(null);
    const [ idqRCodeUrl, setIDQRCodeUrl] = useState(null);
    const [ trainingqRCodeUrl, setTrainingQRCodeUrl] = useState(null);
    const [ memberqRCodeUrl, setMemberQRCodeUrl] = useState(null);
    const [selectedCertificate, setSelectedCertificate] = useState(null);
    const [showSendRequest, setShowSendRequest] = useState(false);
    const [clickedCertificate, setClickedCertificate] = useState('');

    const [partner1KYCComplete, setPartner1KYCComplete] = useState(false);
    const [partner2KYCComplete, setPartner2KYCComplete] = useState(false);
    const [partner1Data, setPartner1Data] = useState({});
    const [partner2Data, setPartner2Data] = useState({});
    const [showPartner1Data, setShowPartner1Data] = useState(false);
    const [showPartner2Data, setShowPartner2Data] = useState(false);

    const [referenceNo, setReferenceNo] = useState("");

    const history = useHistory();




    useEffect(() => {
        getProfileData();
        
    }, []);



    const getProfileData = async () => {
        try {

            const profileData = sessionStorage.getItem('profileData');
            const bytes = profileData ? JSON.parse(profileData) : null;


            console.log('Bytes', bytes)

            setProfileData(bytes);

if (bytes){
    getWalletDoc(bytes)
}

        } catch (error) {
            console.log('Profile data not found');
        }
    };
  //const qrCodeUrl = ``  
//const qrCodeUrl = JSON.stringify(responseData[0]);
const [showAlert, setShowAlert] = useState(false);



const getWalletDoc = (bytes) => {
    try {
        console.log('this is the bytesData:', bytes);
        if (bytes) {
          // Convert key-value object into array of strings: ["name=value", ...]
          const formattedFields = Object.entries(bytes)
            .filter(([key, val]) => typeof val === 'string' || typeof val === 'number') // Optional filtering
            .map(([key, val]) => `${key}=${val}`);
  
          console.log("Formatted Fields:", formattedFields);
  
      
  
          // Create key-value pairs from the formatted fields
          const parsedData = Object.fromEntries(
            formattedFields.map(entry => entry.split('='))
          );
  
          console.log("Parsed Data:", parsedData);
  
          const additionalData = {
            earthId: bytes.earthId || "",
            publicKey: bytes.publicKey || "",
            email: bytes.userEmail || "",
            mobileNumber: bytes.userMobileNo || "",
          };
  
         
            setPartner1KYCComplete(true);
            setPartner1Data(prevData => {
              const updatedData = { ...prevData, ...parsedData, ...additionalData };
              console.log("✅ Updated Partner1 Data:", updatedData);
              return updatedData;
            });
         
  
  
        } else {
          Swal.fire({
            title: "Verification Failed",
            text: "The verification failed. Please try again.",
            icon: "error",
            willClose: () => {
              window.location.reload();
            },
          });
        }
    } catch (error) {
      console.error("Document fetch failed:", error);
      Swal.fire("Error", "Unexpected error occurred", "error");
    }
  };
  




    const createReqCertVC = async (partner1) => {
        try {
            //const signature = await createUserSignature(documentMetadata);
            const data = {
                schemaName: 'AgeProofRequest:1',
                isEncrypted: false,
                dependantVerifiableCredential: [],
                credentialSubject: {
                    "userData": partner1,
                },
            };

            const config = {
                method: 'post',
                url: `${ssiBaseUrl}/api/issuer/verifiableCredential?isCryptograph=false&downloadCryptograph=false`,
                headers: {
                    'X-API-KEY': authorizationKey,
                    did: profileData.userDid,
                    publicKey: profileData.publicKey,
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(data),
            };

            const response = await axios.request(config);
            console.log('VC response', response.data.data.verifiableCredential)
            const verifiableCredential = response.data.data.verifiableCredential;


            // Store the VC using the storeVC API
            const storeVcResponse = await storeVC( verifiableCredential);
            setVcResponse(verifiableCredential)
            // Swal.fire({
            //     icon: 'success',
            //     title: 'Successful',
            //     text: 'On-boarding documents and its verifiable credentials have been submitted successfully.',
            // });

            // Emit the VC data to the socket connection
            //socket.emit('vcData', verifiableCredential);
            // setVerifiableCredentials((prevCredentials) => [...prevCredentials, verifiableCredential]);

            // setShowAllDocs(true)
            return verifiableCredential;

        } catch (error) {
            console.log(error);
            throw error;
        }
    };



    const storeVC = async (verifiableCredential) => {
        try {

            const usernameMarriageLicenseReq = 
            `${(partner1Data.partner1_firstName || partner1Data.firstName || '').trim()}`
        
console.log("this is username:", usernameMarriageLicenseReq);

         const payload = {
                company: usernameMarriageLicenseReq,
                type: 'RequestMarriageLicenseVc',
                vc: verifiableCredential,
            };
            console.log("this is store vc payload:", payload)

            const config = {
                method: 'post',
                //url: 'https://publicdb.myearth.id/api/vc/storeVC',
                url: 'https://agedb.myearth.id/api/vcnew/store',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(payload),
            };

            const response = await axios.request(config);
            console.log('Store VC response:', response.data);
            const newVcId = response.data.vcId
            setReferenceNo(newVcId)
            console.log("newVcID", newVcId)
            // setVcID(newVcId)
            // console.log("VCID", vcID)
            return newVcId;
        } catch (error) {
            console.log(error);
            throw error;
        }
    };



        const [formData, setFormData] = useState({});
        const [sections, setSections] = useState({
            partner1: false,
            partner1_info: false,
            partner1_parents: false,
            partner1_address: false,
            partner1_identity: false,
            partner1_statistics: false,
            partner2: false,
            partner2_info: false,
            partner2_parents: false,
            partner2_address: false,
            partner2_identity: false,
            partner2_statistics: false,
        });
    
        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData({ ...formData, [name]: value });
        };

         // Handle form input changes
    const handleInputChange = (e, partner) => {
        const { name, value } = e.target;
        if (partner == "partner1") {
            setPartner1Data((prevData) => ({ ...prevData, [name]: value }));
        } else if (partner == "partner2"){
            setPartner2Data((prevData) => ({ ...prevData, [name]: value }));
        }
    };
    
  
    
        const handleSubmit = async (e) => {
            e.preventDefault();
        
            if (!partner1KYCComplete) {
                Swal.fire({
                    title: "Error",
                    text: "All fields must be filled before submitting!",
                    icon: "error",
                });
                return;
            }
        
            console.log("Submitting Data:", { partner1Data });
        
            Swal.fire({
                title: "Processing...",
                text: "Submitting Request for Proof of Age...",
                allowOutsideClick: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
        
            try {
                // Clean data to keep only necessary fields
        const filteredPartner1 = cleanPartnerData(partner1Data, "partner1_");

        console.log("Filtered Partner 1 Data:", filteredPartner1);

                const reqCertificateVC = await createReqCertVC(filteredPartner1);
        
                if (reqCertificateVC) {
                    setShowPartner1Data(true);
                    Swal.fire({
                        title: "Success",
                        text: "Submitted Request for Proof of Age!",
                        icon: "success",
                    });
                } else {
                    Swal.fire({
                        title: "Failed",
                        text: "Request for Proof of Age could not be submitted. Please try again later.",
                        icon: "error",
                    });
                }
            } catch (error) {
                console.error("Submission Error:", error);
                Swal.fire({
                    title: "Error",
                    text: "An unexpected error occurred. Please try again later.",
                    icon: "error",
                });
            }
        };
        
    
  
        const [formDataCert, setFormDataCert] = useState({});
      
      const handleChangeCert = (e) => {
          const { name, value } = e.target;
          setFormDataCert({ ...formDataCert, [name]: value });
      };
  
      const handleSubmitCert = (e) => {
          e.preventDefault();
          console.log('Submitted Data:', formData);
          alert('Age Proof Request Submitted!');
      };

      const handleManualAdd = (partner) => {
        console.log(`🟢 handleManualAdd called for: ${partner}`);
    
        if (partner === "Partner1") {
            console.log("✅ Setting partner1KYCComplete to true");
            setPartner1KYCComplete(true);
        } else if (partner === "Partner2") {
            console.log("✅ Setting partner2KYCComplete to true");
            setPartner2KYCComplete(true);
        } else {
            console.warn("⚠️ Unknown partner type received!");
        }
    };
    
    
    const cleanPartnerData = (data, partnerPrefix) => {
        return {
            [`${partnerPrefix}firstName`]: data[`${partnerPrefix}firstName`] || data.firstName || undefined,
            [`${partnerPrefix}phone`]: data[`${partnerPrefix}phone`] || data.userMobileNo || undefined,
            [`${partnerPrefix}dateOfBirth`]: data[`${partnerPrefix}dateOfBirth`] || data.dateOfBirth || undefined,
            [`${partnerPrefix}email`]: data[`${partnerPrefix}email`] || data.email || undefined,
            [`${partnerPrefix}document`]: data[`${partnerPrefix}document`] || data.document || undefined,
        };
    };
    

  return (
    <>
      <header className="navbarNew">
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>
        <nav>
          <ul>
            <li><a href="#">Government</a></li>
            <li><a href="#">Departments</a></li>
            <li><a href="#">Residences</a></li>
            <li><a href="#">Business</a></li>
           
          </ul>
          
        </nav>
      </header>
      <div className="social-bar">
        <a href="#"><FontAwesomeIcon className='soBarIcon' icon={faFacebook}/></a>
        <a href="#"><FontAwesomeIcon className='soBarIcon' icon={faTwitter}/></a>
        <a href="#"><FontAwesomeIcon className='soBarIcon' icon={faLinkedinIn}/></a>
      </div>
      <div className="applyCertSection">
        <div className='cert-titlemc'>Request for Proof of Age</div>
        <div className="partner-container" style={{
    width: "50vw",  // Ensures full viewport width
   // maxWidth: "100%",
   margin: "0 auto",
   //display: "flex", 
   // flexDirection: "column", 
    alignItems: "center",
    justifyContent: "center",
}}>
        <div className='forPartner1'>
       
            <h3 className='section-title' 
            style={{
    // width: "60vw",  // Ensures full viewport width
    maxWidth: "100%",
    display: "flex", 
    flexDirection: "column", 
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center"
}}>User Details</h3>
           

{/* {!partner1KYCComplete && (
<KycFlow partner="Partner1" onComplete={() => handleKYCFlowComplete("Partner1")} onManualAdd={handleManualAdd} />
)} */}


{partner1KYCComplete && !showPartner1Data && (
 <div>
 <div className="section-content" style={{ display: "flex", flexDirection: "column", gap: "10px", padding: "10px" }}>
     <label style={{ fontWeight: "bold", color: "#333" }}>Name:</label>
     <div className="input-container">
     <input 
         name="partner1_firstName" 
         placeholder="Full Name" 
         value={partner1Data.partner1_firstName || partner1Data.firstName || ""} 
         onChange={(e) => handleInputChange(e, "partner1")} 
         required 
         className='validated-input'
         //style={{ padding: "8px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px" }}
     />
{!partner1Data.partner1_firstName && partner1Data.firstName && partner1Data.firstName.trim() !== "" && (
        <FontAwesomeIcon icon={faCircleCheck} className="input-icon" />
    )}
</div>

     <label style={{ fontWeight: "bold", color: "#333" }}>Phone:</label>
     <div className="input-container">
     <input 
         name="partner1_phone" 
         placeholder="Phone Number" 
         value={partner1Data.partner1_phone|| partner1Data.userMobileNo || ""} 
         onChange={(e) => handleInputChange(e, "partner1")} 
         required 
         className='validated-input'
        // style={{ padding: "8px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px" }}
     />
     {!partner1Data.partner1_phone && partner1Data.userMobileNo && partner1Data.userMobileNo.trim() !== "" && (
        <FontAwesomeIcon icon={faCircleCheck} className="input-icon" />
    )}
</div>

     <label style={{ fontWeight: "bold", color: "#333" }}>Email:</label>
     <div className="input-container">
     <input 
         name="partner1_email" 
         value={partner1Data.partner1_email || partner1Data.email || ""} 
         type="email" 
         placeholder="Email" 
         onChange={(e) => handleInputChange(e, "partner1")} 
          className='validated-input'
        // style={{ padding: "8px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px" }}
     />
          {!partner1Data.partner1_email && partner1Data.email && partner1Data.email.trim() !== "" && (
        <FontAwesomeIcon icon={faCircleCheck} className="input-icon" />
    )}
</div>


     <label style={{ fontWeight: "bold", color: "#333" }}>Date of Birth:</label>
     <div className="input-container">
     <input 
         name="partner1_dateOfBirth" 
         value={partner1Data.partner1_dateOfBirth || partner1Data.dateOfBirth || ""} 
         placeholder="Date of Birth" 
         type="date" 
         onChange={(e) => handleInputChange(e, "partner1")} 
         required 
          className='validated-input'
        // style={{ padding: "8px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px" }}
     />
               {!partner1Data.partner1_dateOfBirth && partner1Data.dateOfBirth && partner1Data.dateOfBirth.trim() !== "" && (
        <FontAwesomeIcon icon={faCircleCheck} className="input-icon" />
    )}
</div>
<label style={{ fontWeight: "bold", color: "#333" }}>Source Document:</label>
     <div className="input-container">
     <select 
         name="partner1_document" 
         onChange={(e) => handleInputChange(e, "partner1")} 
         required
          className='validated-input'
        // style={{ padding: "8px", borderRadius: "5px", border: "1px solid #ccc", fontSize: "16px", backgroundColor: "#fff" }}
     >
         <option value="">Select Document</option>
         <option value="Birth Certificate">Birth Certificate</option>
         <option value="Leaving Certificate">Education Certificate</option>
         <option value="Government Issued ID">Government Issued ID</option>
     </select>
     </div>

 </div>

</div>

                   
        )}

{/* Show Partner 1 Data */}
{partner1KYCComplete && showPartner1Data &&(
    <div className="partner-card">
        {/* <h3>👤 Partner 1 Details</h3> */}
        <div className="partner-info">
            <p><strong>Name:</strong> {partner1Data.partner1_firstName || partner1Data.firstName || "N/A"}</p>
            <p><strong>Phone:</strong> {partner1Data.partner1_phone || partner1Data.userMobileNo || "N/A"}</p>
            <p><strong>Email:</strong> {partner1Data.partner1_email || partner1Data.email || "N/A"}</p>
            <p><strong>Date of Birth:</strong> {partner1Data.partner1_dateOfBirth || partner1Data.dateOfBirth || "N/A"}</p>
            <p><strong>Source Document:</strong> {partner1Data.partner1_document || partner1Data.document || "N/A"}</p>
        </div>
    </div>
)}

</div>

       

{partner1KYCComplete && showPartner1Data &&  (
    <div 
        style={{
            backgroundColor: "#d4edda", 
            color: "#155724", 
            padding: "15px", 
            borderRadius: "5px", 
            textAlign: "center", 
            fontSize: "18px", 
            fontWeight: "bold", 
            marginTop: "20px", 
            border: "1px solid #c3e6cb",
            width: "100%",
            maxWidth: "600px",
            margin: "20px auto"
        }}
    >
        🎉 Your request for 'Proof of Age' has been successfully submitted! We will notify you once it is processed.
        <br/>
        Reference Number: {referenceNo}
    </div>
)}
      </div> 
      
     
   


{ !showPartner1Data  && (
 <button
 type="submit"
 className="submit-buttonmc"
 disabled={!partner1KYCComplete }
 onClick={handleSubmit}
>
 Submit Request
</button>
)

}
                       
                  
      </div>
      
      
     
    </>
  )
}

export default ApplyMarriage
